import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from 'axios';

export default function Unsubscribe() {
    const { token } = useParams();
    const [status, setStatus] = useState("loading"); // 'ok' | 'error' | 'loading'

    useEffect(() => {
        axios.get(`/api/messaging/unsubscribe/${token}/`)
            .then(() => setStatus("ok"))
            .catch(() => setStatus("error"));
    }, [token]);

    if (status === "loading") return (
        <div style={{ textAlign: 'center', padding: '2rem' }}>
            <p>Validating request…</p>
        </div>
    );

    if (status === "error") return (
        <div style={{ textAlign: 'center', padding: '2rem' }}>
            <p>Sorry, that link is invalid or expired.</p>
        </div>
    );

    return (
        <div style={{ textAlign: 'center', padding: '2rem' }}>
            <h2>Unsubscribed</h2>
            <p>You will no longer receive these e-mails.
                You can re-enable them any time from your account settings.</p>
            <Link to="/profile/" style={{
                display: 'inline-block',
                marginTop: '1rem',
                padding: '0.5rem 1rem',
                backgroundColor: '#007bff',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '4px',
                transition: 'background-color 0.2s'
            }}>
                Go to Profile
            </Link>
        </div>
    );
}